import {computed, inject, Injectable, signal} from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {LicenceServerService, LicenceServerSummary} from '../../../../../../api';
import {QueryKey} from '../../../../../constants/query-key';

@Injectable()
export class LicenceServerQueryService {
  private readonly licenceServerService = inject(LicenceServerService);

  customerId = signal<number | null>(null);

  licenceServersQuery = injectQuery(() => ({
    queryKey: [QueryKey.LICENCE_SERVERS, this.customerId()],
    queryFn: () => lastValueFrom(this.licenceServerService.getLicenceServersByCustomerId(this.customerId()!)),
    enabled: this.customerId() !== null,
  }));

  licenceServers = computed<LicenceServerSummary[]>(() => this.licenceServersQuery.data()?.licenceServers ?? []);
  isLoading = computed(() => this.licenceServersQuery.isLoading());
}
